import { makeHttpClient, _unwrapAxiosResponse } from "./http";
import env from "@/environment/env.json";

export interface DataManagementCertificates {
  id?: number;
  customer_id: number;
  certificate_name: string;
  supplier_id: number;
  document: File;
  expiry_date: string;
}
function dateFormatter(dt: any) {
  if (dt == "Invalid Date") {
    return null;
  }
  if (dt != null) {
    return dt.toLocaleDateString("fr-CA");
  }
  return dt;
}
export default class DataManagementCertificatesService {
  private httpClient = makeHttpClient();
  create(form: any) {
    if (!form?.customer?.id) {
      throw new Error("Customer is required");
    }

    const headers = {
      headers: {
        "Content-Type": "multipart/form-data",
        tenant: form.customer.id
      }
    };
    const data = new FormData();
    data.append("customer_id", String(form.customer.id));
    if (form.supplier?.id) {
      data.append("supplier_id", String(form.supplier.id));
    }
    data.append("expiry_date", dateFormatter(form.expiry_date));
    const documents = form.document;
    if (documents) {
      for (let i = 0; i < documents.length; i++) {
        const document = documents[i];
        if (document instanceof File || document instanceof Blob) {
          data.append("files", document);
        }
      }
    }
    return _unwrapAxiosResponse(
      this.httpClient.post<DataManagementCertificates>(
        env.certificatesUrl,
        data,
        headers
      )
    );
  }
  get(query: any) {
    console.log("Fetching certificates with query:", query);
    return _unwrapAxiosResponse(
      this.httpClient.get<DataManagementCertificates>(
        env.certificatesUrl + "?" + query
      )
    );
  }
  edit(form: any) {
    if (!form?.customer?.id) {
      throw new Error("Customer is required");
    }

    const headers = {
      headers: {
        "Content-Type": "multipart/form-data",
        tenant: form.customer.id
      }
    };
    const data = new FormData();
    data.append("customer_id", String(form.customer.id));
    if (form.supplier?.id) {
      data.append("supplier_id", String(form.supplier.id));
    }
    data.append("expiry_date", dateFormatter(form.expiry_date));
    const documents = form.document;
    if (documents) {
      for (let i = 0; i < documents.length; i++) {
        const document = documents[i];
        if (document instanceof File || document instanceof Blob) {
          data.append("files", document);
        }
      }
    }
    return _unwrapAxiosResponse(
      this.httpClient.put<DataManagementCertificates>(
        env.certificatesUrl + form.id + "/",
        data,
        headers
      )
    );
  }
  delete(id: any) {
    return _unwrapAxiosResponse(
      this.httpClient.delete<DataManagementCertificates>(
        env.certificatesUrl + id + "/"
      )
    );
  }

  downloadCertificate(id: any) {
    return this.httpClient.get(env.certificatesUrl + id + "/download/", {
      responseType: "blob"
    });
  }

  saveMatchedData(data: any) {
    const products: any[] = Array.isArray(data.product) ? data.product : [];
    const params = {
      product_pack_ids: products.map((item: any) => item.id),
      product_customer_id:
        data?.product_customer_id || products?.[0]?.customer_id
    };
    const product_customer_id =
      data?.product_customer_id || products?.[0]?.customer_id || null;
    if (!product_customer_id) {
      throw new Error("Product customer id is required for manual match");
    }
    const url = `${env.certificatesUrl}${data.certificate[0].id}/add-product-packs/`;
    return _unwrapAxiosResponse(
      this.httpClient.post<DataManagementCertificates>(url, params)
    );
  }
  manualUnmatch(ids: number[], product_customer_id: number | null) {
    if (!product_customer_id) {
      throw new Error("Product customer id is required for manual unmatch");
    }
    const params = { product_pack_ids: ids, product_customer_id };
    const url = `${env.certificatesUrl}unmatch-product-packs/`;
    return _unwrapAxiosResponse(this.httpClient.post(url, params));
  }
}
